// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import asyncMergeSort from 'async-merge-sort'
import { castToString } from 'helpers/reduxFormFunctions'

export const sortData = (arr, { asc, col }, callback) => {
  const sorter = (a, b, cb) => {
    const av = castToString(a[col]).toLowerCase()
    const bv = castToString(b[col]).toLowerCase()

    if (asc) {
      return cb(null, (av >= bv) ? 1 : -1)
    } else {
      return cb(null, (av <= bv) ? 1 : -1)
    }
  }

  return asyncMergeSort(arr, sorter, callback)
}

// which column to sort on.
// NOTE - if you want to sort rows based on form data,
// here's where, you handle that.
export const getSortColByFormValues = () => 'rcnNumber'
